import { saveAs } from "file-saver";
import instance from "@/services/api";
import { showErrorToast } from "@/services";
import { contragentAVRApi } from "./api";

const parseFilenameFromContentDisposition = (disposition, fallback) => {
  if (!disposition) return fallback;
  const utfNameMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utfNameMatch?.[1]) {
    try {
      return decodeURIComponent(utfNameMatch[1]);
    } catch (e) {
      return utfNameMatch[1];
    }
  }
  const asciiNameMatch = disposition.match(/filename="?([^";]+)"?/i);
  if (asciiNameMatch?.[1]) return asciiNameMatch[1];
  return fallback;
};

export const listContragentAVR = async (clientRequestId) => {
  try {
    const res = await contragentAVRApi.list(clientRequestId);
    return res?.data;
  } catch (e) {
    return null;
  }
};

export const createContragentAVR = async (body) => {
  try {
    await contragentAVRApi.create(body);
    return true;
  } catch (e) {
    return false;
  }
};

export const approveContragentAVR = async (contragentAvrId) => {
  try {
    await contragentAVRApi.approve(contragentAvrId);
    return true;
  } catch (e) {
    return false;
  }
};

export const declineContragentAVR = async (contragentAvrId) => {
  try {
    await contragentAVRApi.decline(contragentAvrId);
    return true;
  } catch (e) {
    return false;
  }
};

export const listContractorAgreementForAvrModal = async (clientRequestId) => {
  try {
    const res = await contragentAVRApi.listContractorAgreementForAvrModal(clientRequestId);
    return res?.data;
  } catch (e) {
    return null;
  }
};

export const listContractorsForAvrModal = async (clientRequestId) => {
  try {
    const res = await contragentAVRApi.listContractorsForAvrModal(clientRequestId);
    return Array.isArray(res?.data) ? res.data : [];
  } catch (e) {
    return [];
  }
};

/** Активные компании из company_tab (read_company_for_select). */
export const listCompaniesForAvrSelect = async () => {
  try {
    const res = await contragentAVRApi.listCompaniesForSelect();
    return Array.isArray(res?.data) ? res.data : [];
  } catch (e) {
    return [];
  }
};

export const downloadContragentAVRDocument = async (contragentAvrId) => {
  const url = contragentAVRApi.downloadDocument(contragentAvrId);
  try {
    const res = await instance(true, null, {
      throwError: true,
      showToast: false,
    }).get(url, { responseType: "arraybuffer" });

    const disposition = res.headers?.["content-disposition"] || "";
    const fileName = parseFilenameFromContentDisposition(
      disposition,
      `АВР ${contragentAvrId}.pdf`
    );

    const blob = new Blob([res.data], { type: "application/pdf" });
    saveAs(blob, fileName);
  } catch (e) {
    try {
      const data = e?.response?.data;
      if (data) {
        const text =
          typeof data === "string"
            ? data
            : new TextDecoder("utf-8").decode(new Uint8Array(data));
        const parsed = JSON.parse(text);
        if (parsed?.error) return showErrorToast(parsed.error);
      }
    } catch (parseErr) {}
    showErrorToast("Ошибка при скачивании АВР");
  }
};
